import React from 'react';
import { Routes, Route } from 'react-router-dom';
import InvestorProfile from 'components/simulation/types/per/InvestorProfile';
import Product from 'components/simulation/types/per/Product';
import Details from 'components/simulation/types/per/Details';

const Router = () => (
    <Routes>
        <Route path="/profile" element={<InvestorProfile />} />
        <Route path="/product" element={<Product />} />
        <Route path="/simulation" element={<Details />} />
    </Routes>
);

export default Router;
